import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { authWorkspaceSchema, composeAuthWorkspace } from "../../schemas/auth";

const requestSchema = yup.object({
  wpuId: yup.number().required(),
  googleAuthCode: yup.string().required(),
  authToken: yup.string().required(),
  trustDevice: yup.boolean().notRequired(),
});

const responseSchema = yup.object({
  accessToken: yup.string().nullable(),
  workspaces: yup.array().of(authWorkspaceSchema).required(),
  trustedDeviceToken: yup.string().nullable(),
  userHash: yup.string().nullable(),
});

const composeResponse = (res) => {
  const data = res?.data?.data || {};

  return {
    accessToken: data.tokens?.web || null,
    workspaces: data?.workspaces?.map(composeAuthWorkspace) || [],
    trustedDeviceToken: data?.trusted_device_token || null,
    userHash: data?.user_hash || null,
  };
};

export function useVerify2FaGoogleMutation(options = {}) {
  return useMutation(async (dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    const res = await http.post(HTTP_ENDPOINTS.postVerify2FaGoogle(), {
      wpuId: req.wpuId,
      googleAuthCode: req.googleAuthCode,
      authToken: req.authToken,
      trusted_device: req.trustDevice,
    });
    return responseSchema.validateSync(composeResponse(res), {
      strict: true,
    });
  }, options);
}
